export interface IManifest {
  gameServerVersion: string;
  endpoints: { [key: string]: string };
  useGtag: boolean;
}

/*
 * # Manifest Supplier
 *
 * A singleton class that provides the manifest object, handles amendment of the manifest object and provides a method to retrieve the manifest object.
 * */
export class CoreManifestSupplierClass {
  private static instance: CoreManifestSupplierClass;

  private manifest: IManifest = {
    gameServerVersion: GAME_SERVER_VERSION,
    endpoints: {
      playerConfig: ENDPOINT_PLAYER_CONFIG,
    },
    useGtag: USE_GTAG,
  };

  public static getInstance(): CoreManifestSupplierClass {
    if (!CoreManifestSupplierClass.instance) {
      CoreManifestSupplierClass.instance = new CoreManifestSupplierClass();
    }
    return CoreManifestSupplierClass.instance;
  }

  getManifest(): IManifest {
    return this.manifest;
  }
}

export const CoreManifestSupplier = CoreManifestSupplierClass.getInstance();

export const CoreManifest = CoreManifestSupplier.getManifest();
